// src/data/products.js
const products = [
  { 
    id: 1, 
    name: 'Diamond Ring Red', 
    prices: {
    '6"': 380,
    '7"': 400,
    '8"': 430,
    '9"': 480,
    },
    category: 'Rings', 
    description: 'Elegant diamond ring with a vibrant red stone.', 
    colors: ['Silver', 'Gold'], 
    images: {
      'Silver_6': 'https://m.media-amazon.com/images/I/51WavZ42DHL._AC_SY535_.jpg',
      'Silver_7': 'https://m.media-amazon.com/images/I/61Eq1noLjOL._AC_SY535_.jpg',
      'Silver_8': 'https://m.media-amazon.com/images/I/51WavZ42DHL._AC_SY535_.jpg',
      'Silver_9': 'https://m.media-amazon.com/images/I/61Eq1noLjOL._AC_SY535_.jpg',
      'Gold_6': 'https://m.media-amazon.com/images/I/51z5Ajm9pOL._AC_SY535_.jpg',
      'Gold_7': 'https://m.media-amazon.com/images/I/71mKBUuUviL._AC_SY535_.jpg',
      'Gold_8': 'https://m.media-amazon.com/images/I/51z5Ajm9pOL._AC_SY535_.jpg',
      'Gold_9': 'https://m.media-amazon.com/images/I/71mKBUuUviL._AC_SY535_.jpg',
    },
    material: '18k White Gold',
    weight: '4.5g',
    size: 'Resizable (6-8)',
    additionalDetails: 'Features a 1-carat center stone with side diamonds for extra sparkle. Hypoallergenic and tarnish-resistant.'
  },
  { 
    id: 2, 
    name: 'Diamond Ring Blue', 
    prices: {
    '6"': 380,
    '7"': 400,
    '8"': 430,
    '9"': 480,
    },
    category: 'Rings', 
    description: 'Blue stone ring with intricate detailing.', 
    colors: ['Silver', 'Gold'],
    images: {
      'Silver_6': 'https://m.media-amazon.com/images/I/51BjP30mz5S._AC_SY535_.jpg',
      'Silver_7': 'https://m.media-amazon.com/images/I/71ueVPYStJS._AC_SY535_.jpg',
      'Silver_8': 'https://m.media-amazon.com/images/I/51BjP30mz5S._AC_SY535_.jpg',
      'Silver_9': 'https://m.media-amazon.com/images/I/71ueVPYStJS._AC_SY535_.jpg',
      'Gold_6': 'https://m.media-amazon.com/images/I/611HnMigpSL._AC_SY535_.jpg',
      'Gold_7': 'https://m.media-amazon.com/images/I/71tP4xQ0wZL._AC_SY535_.jpg',
      'Gold_8': 'https://m.media-amazon.com/images/I/611HnMigpSL._AC_SY535_.jpg',
      'Gold_9': 'https://m.media-amazon.com/images/I/71tP4xQ0wZL._AC_SY535_.jpg',
    },
    material: '14k Yellow Gold',
    weight: '5g',
    size: 'Fixed size 7',
    additionalDetails: 'Hand-set sapphire with a halo of diamonds. Comes with a certificate of authenticity.'
  },
  { 
    id: 3, 
    name: 'Gold Earrings', 
    price: 200, 
    category: 'Earrings', 
    description: 'Gold hoop earrings for everyday wear.', 
    colors: ['Silver', 'Gold'], 
    images: [
      'https://m.media-amazon.com/images/I/61UK3Qf-jWL._AC_SY535_.jpg',
      'https://m.media-amazon.com/images/I/61WIyPl7HAL._AC_SY535_.jpg',
    ],
    material: '18k Gold Plated',
    weight: '2g per earring',
    size: '20mm diameter',
    additionalDetails: 'Lightweight and comfortable. Secure clasp to prevent loss.'
  },
  { 
    id: 4, 
    name: 'Pearl Earrings', 
    price: 300, 
    category: 'Earrings', 
    description: 'Pearl drop earrings with a classic touch.', 
    colors: ['Silver', 'Gold'], 
    images: [
      'https://m.media-amazon.com/images/I/51CPUITI5CL._AC_SY535_.jpg',
      'https://m.media-amazon.com/images/I/612cjq9WwBL._AC_SY535_.jpg'
    ],
    material: 'Sterling Silver',
    weight: '3g per earring',
    size: '30mm drop',
    additionalDetails: 'Cultured freshwater pearls. Suitable for sensitive ears.'
  },
  { 
    id: 5, 
    name: 'Necklace Chain', 
    prices: {
    '16"': 380,
    '18"': 400,
    '20"': 430,
    '24"': 480,
    }, 
    category: 'Necklaces', 
    description: 'Simple chain necklace for layering.', 
    colors: ['Silver', 'Gold'], 
    images: {
      'Silver_16': 'https://m.media-amazon.com/images/I/61yESyj1cGL._AC_SY535_.jpg',
      'Silver_18': 'https://m.media-amazon.com/images/I/614Mght4FrL._AC_SY535_.jpg',
      'Silver_20': 'https://m.media-amazon.com/images/I/61yESyj1cGL._AC_SY535_.jpg',
      'Silver_24': 'https://m.media-amazon.com/images/I/614Mght4FrL._AC_SY535_.jpg',
      'Gold_16': 'https://m.media-amazon.com/images/I/61kqHXSYfeL._AC_SY535_.jpg',
      'Gold_18': 'https://m.media-amazon.com/images/I/61v9hBnj8IL._AC_SY535_.jpg',
      'Gold_20': 'https://m.media-amazon.com/images/I/61kqHXSYfeL._AC_SY535_.jpg',
      'Gold_24': 'https://m.media-amazon.com/images/I/61v9hBnj8IL._AC_SY535_.jpg',
    },
    material: '14k Gold Filled',
    weight: '10g',
    size: '18 inches',
    additionalDetails: 'Adjustable length with extender chain. Versatile for pendants.'
  },
  { 
    id: 6, 
    name: 'Gemstone Necklace', 
    prices: {
    '16"': 380,
    '18"': 400,
    '20"': 430,
    '24"': 480,
    },  
    category: 'Necklaces', 
    description: 'Gemstone pendant with chain.', 
    colors: ['Silver', 'Gold'], 
    images: {
      'Silver_16': 'https://m.media-amazon.com/images/I/71opepyUZKL._AC_SY535_.jpg',
      'Silver_18': 'https://m.media-amazon.com/images/I/619apnzMJyL._AC_SY535_.jpg',
      'Silver_20': 'https://m.media-amazon.com/images/I/71opepyUZKL._AC_SY535_.jpg',
      'Silver_24': 'https://m.media-amazon.com/images/I/619apnzMJyL._AC_SY535_.jpg',
      'Gold_16': 'https://m.media-amazon.com/images/I/51kR4Jezg7L._AC_SY535_.jpg',
      'Gold_18': 'https://m.media-amazon.com/images/I/51qM1OfQJnL._AC_SY535_.jpg',
      'Gold_20': 'https://m.media-amazon.com/images/I/51kR4Jezg7L._AC_SY535_.jpg',
      'Gold_24': 'https://m.media-amazon.com/images/I/51qM1OfQJnL._AC_SY535_.jpg',
    },
    material: 'Sterling Silver with Gemstone',
    weight: '15g',
    size: '20 inches',
    additionalDetails: 'Natural gemstone pendant. Ethically sourced materials.'
  },
  { 
    id: 7, 
    name: 'Bracelet Bangle', 
    price: 150, 
    category: 'Bracelets', 
    description: 'Gold bangle for stacking.', 
    colors: ['Silver', 'Gold'], 
    images: [
      'https://m.media-amazon.com/images/I/51LAd9ROEyL._AC_SY535_.jpg',
      'https://m.media-amazon.com/images/I/610VsCaFMXL._AC_SY535_.jpg'
    ],
    material: '18k Gold Plated',
    weight: '8g',
    size: '7 inches',
    additionalDetails: 'Hinged for easy wear. Engraveable surface.'
  },
  { 
    id: 8, 
    name: 'Charm Bracelet', 
    price: 250, 
    category: 'Bracelets', 
    description: 'Charm bracelet with customizable charms.', 
    colors: ['Silver', 'Gold'], 
    images: [
      'https://m.media-amazon.com/images/I/716kbv1BHyL._AC_SY535_.jpg',
      'https://m.media-amazon.com/images/I/71c5a2n-RIL._AC_SY535_.jpg'
    ],
    material: 'Sterling Silver',
    weight: '12g',
    size: '7.5 inches',
    additionalDetails: 'Includes 3 starter charms. Add more for personalization.'
  },
  { 
    id: 9, 
    name: 'Emerald Ring', 
    prices: {
    '6"': 380,
    '7"': 400,
    '8"': 430,
    '9"': 480,
    },
    category: 'Rings', 
    description: 'Emerald stone ring with vintage design.', 
    colors: ['Silver', 'Gold'], 
    images: {
      'Silver_6': 'https://m.media-amazon.com/images/I/51zdgGncLyL._AC_SY535_.jpg',
      'Silver_7': 'https://m.media-amazon.com/images/I/81+eos-w5HL._AC_SY535_.jpg',
      'Silver_8': 'https://m.media-amazon.com/images/I/51zdgGncLyL._AC_SY535_.jpg',
      'Silver_9': 'https://m.media-amazon.com/images/I/81+eos-w5HL._AC_SY535_.jpg',
      'Gold_6': 'https://m.media-amazon.com/images/I/81+eos-w5HL._AC_SY535_.jpg',
      'Gold_7': 'https://m.media-amazon.com/images/I/61H2dPTqMiL._AC_SY535_.jpg',
      'Gold_8': 'https://m.media-amazon.com/images/I/81+eos-w5HL._AC_SY535_.jpg',
      'Gold_9': 'https://m.media-amazon.com/images/I/61H2dPTqMiL._AC_SY535_.jpg',
    },
    material: '14k White Gold',
    weight: '6g',
    size: 'Resizable (5-7)',
    additionalDetails: '0.8-carat emerald with diamond accents. Includes cleaning cloth.'
  },
  { 
    id: 10, 
    name: 'Stud Earrings', 
    price: 100, 
    category: 'Earrings', 
    description: 'Diamond studs for a subtle look.', 
    colors: ['Silver', 'Gold'], 
    images: [
      'https://m.media-amazon.com/images/I/51bMqzFcUVL._AC_SY535_.jpg',
      'https://m.media-amazon.com/images/I/51E0py9vi9L._AC_SY535_.jpg'
    ],
    material: 'Sterling Silver',
    weight: '1g per earring',
    size: '5mm stud',
    additionalDetails: 'Lab-created diamonds. Butterfly backing for security.'
  },
  { 
    id: 11, 
    name: 'Layered Necklace', 
    prices: {
    '16"': 380,
    '18"': 400,
    '20"': 430,
    '24"': 480,
    }, 
    category: 'Necklaces', 
    description: 'Layered gold necklace for boho style.', 
    colors: ['Silver', 'Gold'], 
    images: {
      'Silver_16': 'https://m.media-amazon.com/images/I/81lBN+uLtvL._AC_SY535_.jpg',
      'Silver_18': 'https://m.media-amazon.com/images/I/61Dah1s3ryL._AC_SY535_.jpg',
      'Silver_20': 'https://m.media-amazon.com/images/I/81lBN+uLtvL._AC_SY535_.jpg',
      'Silver_24': 'https://m.media-amazon.com/images/I/61Dah1s3ryL._AC_SY535_.jpg',
      'Gold_16': 'https://m.media-amazon.com/images/I/518guykSqoL._AC_SY535_.jpg',
      'Gold_18': 'https://m.media-amazon.com/images/I/8187ZC89oUL._AC_SY535_.jpg',
      'Gold_20': 'https://m.media-amazon.com/images/I/518guykSqoL._AC_SY535_.jpg',
      'Gold_24': 'https://m.media-amazon.com/images/I/8187ZC89oUL._AC_SY535_.jpg',
    },
    material: '14k Rose Gold Plated',
    weight: '12g',
    size: '16-18 inches',
    additionalDetails: 'Three layers with adjustable clasps. Mix and match.'
  },
  { 
    id: 12, 
    name: 'Tennis Bracelet', 
    price: 500, 
    category: 'Bracelets', 
    description: 'Diamond tennis bracelet for elegance.', 
    colors: ['Silver', 'Gold'], 
    images: [
      'https://m.media-amazon.com/images/I/718K1BCon4L._AC_SY535_.jpg',
      'https://m.media-amazon.com/images/I/51-hPZqCMoL._AC_SY535_.jpg'
    ],
    material: '18k White Gold',
    weight: '15g',
    size: '7 inches',
    additionalDetails: '2-carat total diamond weight. Safety clasp included.'
  },
];

export default products;